export enum Status {
    INACTIVE = 0,
    ACTIVE = 1,
    ALL = 2
}